<template>
  <div class="extended-search-wrapper">
    <div v-if="saved_filters" class="extended-search-saved">
      <ul>
        <li v-for="(item, index) in saved_filters" :key="index" @click="useSavedFilter(item)">
          {{ $t(item.name) }}
        </li>
      </ul>
    </div>

    <div class="extended-search">
      <div class="extended-search__rules">
        <div v-for="(group, index_group) in groups" :key="index_group" class="extended-search__wrapper">
          <div class="extended-search__group__title">a zároveň</div>

          <div class="extended-search__group">
            <div
              v-for="(item, index_item) in group.items"
              :key="index_group + 'd' + index_item"
              class="extended-search__item d-flex justify-content-between"
            >
              <div class="d-flex extended-search__item__wrapper">
                <div class="d-flex extended-search__item__select">
                  <div class="custom-control__select">
                    <div
                      class="custom-control__select__selected"
                      @click="
                        () => {
                          if (opened == index_group + 'd' + index_item) opened = ''
                          else opened = index_group + 'd' + index_item
                        }
                      "
                    >
                      <span class="gray-text">{{ item.name ? $t(item.name) : $t("vybertePravidlo") }}</span>
                    </div>
                    <div
                      class="custom-control__select__options"
                      :class="{
                        opened: openedFilter == index_group + 'd' + index_item ? true : false
                      }"
                    >
                      <div
                        v-for="(option, option_index) in filterType"
                        :key="option_index"
                        @click="selectOption(option, index_group, index_item)"
                      >
                        <div
                          v-if="!selectedParameters.slice(0, index_group).find((type) => type == option.type)"
                          class="custom-control__select__option d-flex align-items-center"
                        >
                          <span class="font-weight-light">
                            {{ $t(option.name) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="['custDeviceName', 'deviceId', 'name'].includes(item.type)"
                    class="d-flex extended-search__item__group"
                  >
                    <div class="ml-2 custom-control__select">
                      <div
                        class="custom-control__select__selected"
                        @click="
                          () => {
                            if (opened == index_group + 'i' + index_item) opened = ''
                            else opened = index_group + 'i' + index_item
                          }
                        "
                      >
                        <span class="gray-text">{{ item.operator.name ? $t(item.operator.name) : $t("CHOOSE") }}</span>
                      </div>
                      <div
                        class="custom-control__select__options"
                        :class="{
                          opened: openedFilter == index_group + 'i' + index_item ? true : false
                        }"
                      >
                        <div
                          v-for="(option, option2_index) in filterTypeDevice"
                          :key="index_group + 'i' + index_item + 'o' + option2_index"
                          :class="index_group + 'i' + index_item + 'o' + option2_index"
                          @click="selectOperatorOption(option, index_group, index_item)"
                        >
                          <div class="custom-control__select__option d-flex align-items-center">
                            <span class="font-weight-light">
                              {{ $t(option.name) }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="ml-2 custom-control__select custom-control__custom-input custom-control__custom-input--smallpadding"
                    >
                      <input
                        v-model="item.value"
                        type="text"
                        :class="index_group + 'f' + index_item"
                        :name="item"
                        :placeholder="$t('WRITE')"
                      />
                    </div>
                  </div>

                  <div v-if="item.type == 'status'" class="d-flex extended-search__item__group">
                    <div class="ml-2 custom-control__select">
                      <div
                        class="custom-control__select__selected"
                        :class="item.arrayValue.length > 0 ? 'custom-control__select__selected--atoms' : ''"
                        @click="
                          () => {
                            if (opened == index_group + 'i' + index_item) opened = ''
                            else opened = index_group + 'i' + index_item
                          }
                        "
                      >
                        <div class="d-flex flex-wrap">
                          <span v-if="item.arrayValue.length == 0" class="gray-text">
                            {{ $t("vyberteTagZeSeznamu") }}
                          </span>

                          <div v-else class="d-flex selected-tags">
                            <span
                              v-for="(selected, index) in item.arrayValue"
                              :key="index"
                              class="mr-1 atom-tag d-flex justify-content-between"
                            >
                              <span v-if="selected == 'active'">{{ $t("SEARCH_DEVICE_ACTIVE") }}</span>
                              <span v-if="selected == 'preregistration'">
                                {{ $t("SEARCH_DEVICE_PREREGISTRATION") }}
                              </span>
                              <span v-if="selected == 'suspended'">{{ $t("SEARCH_DEVICE_SUSPENDED") }}</span>
                              <span v-if="selected == 'standby'">{{ $t("SEARCH_DEVICE_STANDBY") }}</span>
                              <img
                                src="@/assets/icons/actions/ico-ico-delete-light.svg"
                                class="ml-2"
                                @click="
                                  () => {
                                    addRemoveArrayValue(selected, index_group, index_item)
                                    if (opened == index_group + 'i' + index_item) opened = ''
                                    else opened = index_group + 'i' + index_item
                                  }
                                "
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        class="custom-control__select__options"
                        :class="{
                          opened: openedFilter == index_group + 'i' + index_item ? true : false
                        }"
                      >
                        <div
                          v-for="(option, index) in filterTypeDeviceStatus"
                          :key="index"
                          class="custom-control__select__option d-flex align-items-center"
                          @click="addRemoveArrayValue(option.value, index_group, index_item)"
                        >
                          <div class="d-flex font-weight-light align-items-center">
                            <div class="check">
                              <img
                                v-if="item.arrayValue && item.arrayValue.indexOf(option.value) > -1"
                                src="@/assets/icons/check.svg"
                                class=""
                              />
                            </div>
                            <div v-if="option.value == 'active'" class="atom-circle atom-circle--success">
                              <div v-tooltip :title="$t('activeZarizeniCerpaSluzbu')">A</div>
                            </div>
                            <div v-if="option.value == 'preregistration'" class="atom-circle atom-circle--warning">
                              <div v-tooltip :title="$t('PREDREGISTRACE')">P</div>
                            </div>
                            <div v-if="option.value == 'suspended'" class="atom-circle atom-circle--danger">
                              <div v-tooltip :title="$t('overLimitZarizeniPrekrociloLimit')">O</div>
                            </div>
                            <div v-if="option.value == 'standby'" class="atom-circle atom-circle--gray">
                              <div v-tooltip :title="$t('standByZarizeniJeNeaktivni')">S</div>
                            </div>
                            <span class="ml-1">{{ $t(option.name) }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="item.type == 'bateryStatus'" class="d-flex extended-search__item__group">
                    <div class="ml-2 custom-control__select">
                      <div
                        class="custom-control__select__selected"
                        @click="
                          () => {
                            if (opened == index_group + 'i' + index_item) opened = ''
                            else opened = index_group + 'i' + index_item
                          }
                        "
                      >
                        <span class="gray-text">{{ item.operator.name ? $t(item.operator.name) : $t("CHOOSE") }}</span>
                      </div>
                      <div
                        class="custom-control__select__options"
                        :class="{
                          opened: openedFilter == index_group + 'i' + index_item ? true : false
                        }"
                      >
                        <div
                          v-for="(option, option2_index) in filterTypeBateryStatus"
                          :key="index_group + 'i' + index_item + 'o' + option2_index"
                          :class="index_group + 'i' + index_item + 'o' + option2_index"
                          @click="selectOperatorOption(option, index_group, index_item)"
                        >
                          <div class="custom-control__select__option d-flex align-items-center">
                            <div class="d-flex font-weight-light align-items-center">
                              <img v-if="option.value == 100" src="@/assets/icons/battery/ico-battery-full.svg" />
                              <img v-if="option.value == 80" src="@/assets/icons/battery/ico-battery-80.svg" />
                              <img v-if="option.value == 60" src="@/assets/icons/battery/ico-battery-60.svg" />
                              <img v-if="option.value == 40" src="@/assets/icons/battery/ico-battery-40.svg" />
                              <img v-if="option.value == 20" src="@/assets/icons/battery/ico-battery-20.svg" />
                              <img v-if="option.value == 255" src="@/assets/icons/battery/ico-battery-na.svg" />
                              <img v-if="option.value == 'NULL'" src="@/assets/icons/battery/ico-battery-na.svg" />
                              <img v-if="option.value == 0" src="@/assets/icons/battery/ico-battery-napajeni.svg" />

                              {{ $t(option.name) }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="item.type == 'deviceType'" class="d-flex extended-search__item__group">
                    <div class="ml-2 custom-control__select">
                      <div
                        class="custom-control__select__selected"
                        @click="
                          () => {
                            if (opened == index_group + 'i' + index_item) opened = ''
                            else opened = index_group + 'i' + index_item
                          }
                        "
                      >
                        <span class="gray-text">{{ item.value ? $t(item.value) : $t("CHOOSE") }}</span>
                      </div>
                      <div
                        class="custom-control__select__options"
                        :class="{
                          opened: openedFilter == index_group + 'i' + index_item ? true : false
                        }"
                      >
                        <div
                          v-for="(option, option2_index) in filterTypeDeviceType"
                          :key="index_group + 'i' + index_item + 'o' + option2_index"
                          :class="index_group + 'i' + index_item + 'o' + option2_index"
                          @click="selectValueOption(option, index_group, index_item)"
                        >
                          <div class="custom-control__select__option d-flex align-items-center">
                            <span class="font-weight-light">
                              {{ $t(option.name) }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="item.type == 'tags'" class="d-flex extended-search__item__group">
                    <div class="ml-2 custom-control__select">
                      <div
                        class="custom-control__select__selected"
                        :class="item.arrayValue.length > 0 ? 'custom-control__select__selected--atoms' : ''"
                        @click="
                          () => {
                            if (opened == index_group + 'i' + index_item) opened = ''
                            else opened = index_group + 'i' + index_item
                          }
                        "
                      >
                        <div class="d-flex flex-wrap">
                          <span v-if="item.arrayValue.length == 0" class="gray-text">
                            {{ $t("vyberteTagZeSeznamu") }}
                          </span>
                          <div v-else class="d-flex selected-tags">
                            <span
                              v-for="(selected, index) in item.arrayValue"
                              :key="index"
                              class="mr-1 atom-tag d-flex justify-content-between"
                            >
                              <span>{{ selected }}</span>
                              <img
                                src="@/assets/icons/actions/ico-ico-delete-light.svg"
                                class="ml-2"
                                @click="
                                  () => {
                                    addRemoveArrayValue(selected, index_group, index_item)
                                    if (opened == index_group + 'i' + index_item) opened = ''
                                    else opened = index_group + 'i' + index_item
                                  }
                                "
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        class="custom-control__select__options"
                        :class="{
                          opened: openedFilter == index_group + 'i' + index_item ? true : false
                        }"
                      >
                        <div
                          v-for="(option, index) in allTags"
                          :key="index"
                          class="custom-control__select__option d-flex align-items-center"
                          @click="addRemoveArrayValue(option, index_group, index_item)"
                        >
                          <div v-if="option != null" class="d-flex align-items-center">
                            <div class="check">
                              <img
                                v-if="item.arrayValue && item.arrayValue.indexOf(option) > -1"
                                src="@/assets/icons/check.svg"
                                class=""
                              />
                            </div>
                            <span class="font-weight-light">{{ option }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="item.type == 'custServiceId'" class="d-flex extended-search__item__group">
                    <div class="ml-2 custom-control__select">
                      <div
                        class="custom-control__select__selected"
                        :class="item.arrayValue.length > 0 ? 'custom-control__select__selected--atoms' : ''"
                        @click="
                          () => {
                            if (opened == index_group + 'i' + index_item) opened = ''
                            else opened = index_group + 'i' + index_item
                          }
                        "
                      >
                        <div class="d-flex flex-wrap">
                          <span v-if="item.arrayValue.length == 0" class="gray-text">
                            {{ $t("vyberteSluzbuZeSeznamu") }}
                          </span>
                          <div v-else class="d-flex selected-tags">
                            <span
                              v-for="(selected, index) in item.arrayValue"
                              :key="index"
                              class="mr-1 atom-tag d-flex justify-content-between"
                            >
                              <span>{{ selected }}</span>
                              <img
                                src="@/assets/icons/actions/ico-ico-delete-light.svg"
                                class="ml-2"
                                @click="
                                  () => {
                                    addRemoveArrayValue(selected, index_group, index_item)
                                    if (opened == index_group + 'i' + index_item) opened = ''
                                    else opened = index_group + 'i' + index_item
                                  }
                                "
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        class="custom-control__select__options"
                        :class="{
                          opened: openedFilter == index_group + 'i' + index_item ? true : false
                        }"
                      >
                        <div
                          v-for="(option, index) in allServices"
                          :key="index"
                          class="custom-control__select__option d-flex align-items-center"
                          @click="addRemoveArrayValue(option.custServiceId, index_group, index_item)"
                        >
                          <div v-if="option != null" class="d-flex align-items-center">
                            <div class="check">
                              <img
                                v-if="item.arrayValue && item.arrayValue.indexOf(option.custServiceId) > -1"
                                src="@/assets/icons/check.svg"
                                class=""
                              />
                            </div>
                            <span class="font-weight-light">{{ option.custServiceId }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="item.type == 'deviceGroupId'" class="d-flex extended-search__item__group">
                    <div class="ml-2 custom-control__select">
                      <div
                        class="custom-control__select__selected"
                        :class="item.arrayValue.length > 0 ? 'custom-control__select__selected--atoms' : ''"
                        @click="
                          () => {
                            if (opened == index_group + 'i' + index_item) opened = ''
                            else opened = index_group + 'i' + index_item
                          }
                        "
                      >
                        <div class="d-flex flex-wrap">
                          <span v-if="item.arrayValue.length == 0" class="gray-text">
                            {{ $t("vyberteSkupinuZeSeznamu") }}
                          </span>
                          <div v-else class="d-flex selected-tags">
                            <span
                              v-for="(selected, index) in item.arrayValue"
                              :key="index"
                              class="mr-1 atom-tag d-flex justify-content-between"
                            >
                              <span>{{ getGroupName(selected) }}</span>
                              <img
                                src="@/assets/icons/actions/ico-ico-delete-light.svg"
                                class="ml-2"
                                @click="
                                  () => {
                                    addRemoveArrayValue(selected, index_group, index_item)
                                    if (opened == index_group + 'i' + index_item) opened = ''
                                    else opened = index_group + 'i' + index_item
                                  }
                                "
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        class="custom-control__select__options"
                        :class="{
                          opened: openedFilter == index_group + 'i' + index_item ? true : false
                        }"
                      >
                        <div
                          v-for="(option, index) in allDeviceGroups"
                          :key="index"
                          class="custom-control__select__option d-flex align-items-center"
                          @click="addRemoveArrayValue(option.deviceGroupId, index_group, index_item)"
                        >
                          <div v-if="option != null" class="d-flex align-items-center">
                            <div class="check">
                              <img
                                v-if="item.arrayValue && item.arrayValue.indexOf(option.deviceGroupId) > -1"
                                src="@/assets/icons/check.svg"
                                class=""
                              />
                            </div>
                            <span class="font-weight-light">
                              {{ option.deviceGroupName }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="item.type == 'lastMessageIn'" class="d-flex extended-search__item__group type-date">
                    <div class="ml-2 custom-control__select">
                      <div
                        class="custom-control__select__selected"
                        @click="
                          () => {
                            if (opened == index_group + 'i' + index_item) opened = ''
                            else opened = index_group + 'i' + index_item
                          }
                        "
                      >
                        <span class="gray-text">{{ item.operator.name ? $t(item.operator.name) : $t("CHOOSE") }}</span>
                      </div>
                      <div
                        class="custom-control__select__options"
                        :class="{
                          opened: openedFilter == index_group + 'i' + index_item ? true : false
                        }"
                      >
                        <div
                          v-for="(option, index) in dateSelect"
                          :key="index"
                          class="custom-control__select__option d-flex align-items-center"
                          @click="selectOperatorOption(option, index_group, index_item)"
                        >
                          <div v-if="option != null" class="d-flex align-items-center">
                            <span class="font-weight-light">
                              {{ $t(option.name) }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="item.operator.value == 'from_to'"
                    class="d-flex extended-search__item__group ml-0 ml-md-2 type-date-select custom-control__custom-input"
                  >
                    <DatePicker
                      ref="picker"
                      v-model="groups[index_group].items[index_item].dateRange"
                      teleport
                      :locale="locale === 'cz' ? 'cs' : locale"
                      :format="(date) => `${$filters.date(date[0])} - ${$filters.date(date[1])}`"
                      :enable-time-picker="false"
                      :range="{ partialRange: false }"
                      :select-text="$t('zobrazit')"
                      :cancel-text="$t('zpet')"
                      :multi-calendars="2"
                      @update:model-value="selectDate(index_group, index_item)"
                    >
                      <template #input-icon />
                    </DatePicker>
                  </div>
                </div>
                <div class="d-block d-sm-flex extended-search__item__controll">
                  <button
                    v-if="index_group < filterType.length - 1"
                    class="mt-2 mt-sm-0 ml-0 ml-sm-2"
                    @click="addGroup(index_group + 1)"
                  >
                    <span>+</span>
                    <u>{{ $t("FILTER_A") }}</u>
                  </button>
                  <!--
                  <button
                    v-if="item.operator.type == 'eq'"
                    @click="addItem(index_group, index_item + 1)"
                  >
                    <span>+</span> <u>Nebo</u>
                  </button>
                  -->
                </div>
              </div>

              <div class="d-flex extended-search__item__delete">
                <button @click="groups.length == 1 ? clearFilter() : deleteItem(index_group, index_item)">
                  <img src="@/assets/icons/actions/ico-ico-delete-l.svg" class="" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="extended-search__controll clearfix">
        <div class="extended-search__inner extended-search__inner--left">
          <button class="extended-search__btn extended-search__btn--submit" @click="submitFilter()">
            {{ $t("SHOW_RESULT") }}
          </button>
          <button class="extended-search__btn extended-search__btn--clear" @click="clearFilter()">
            {{ $t("REMOVE_FILTERS") }}
          </button>
        </div>
        <!--
        <div class="extended-search__inner extended-search__inner--right">
          <button
            v-if="!isPrepareToSave"
            @click="prepareToSave()"
            class="extended-search__btn extended-search__btn--save"
          >
            {{ $t("ulozitTentoFiltr") }}
          </button>
          <div v-if="isPrepareToSave">
            <input v-model="filterName" type="text" />
            <button
              @click="saveFilter()"
              class="extended-search__btn extended-search__btn--save"
            >
              {{ $t("ulozit") }}
            </button>
          </div>
        </div>
        -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import DatePicker from "@vuepic/vue-datepicker"
import "@vuepic/vue-datepicker/dist/main.css"
import { useProjectStore } from "@/store/modules/project"
import { useGroupsStore } from "@/store/modules/groups"

export default {
  components: {
    DatePicker
  },
  props: {
    filterType: Array
  },
  setup() {
    const projectStore = useProjectStore()
    const groupsStore = useGroupsStore()

    return { projectStore, groupsStore }
  },
  emits: ["setFilterData", "close"],
  data() {
    return {
      projectId: this.$route.params.projectId,
      dateFrom: "",
      dateTo: "",
      dateRange: [new Date().setDate(new Date().getDate() - 5), new Date()],
      saved_filters: [],
      filterName: "",
      isPrepareToSave: false,
      activeItem: -1,
      activeGroup: -1,
      allServices: [],
      opened: "",
      selectedParameters: [],
      fullText: [],
      filterTypeDevice: [
        {
          name: "je",
          type: "eq"
        },
        {
          name: "IS_NOT",
          type: "noteq"
        },
        //{
        //  name: "konciNa",
        //  type: "endsWith"
        //},
        //{
        //  name: "obsahuje",
        //  type: "like"
        //},
        {
          name: "zacinaNa",
          type: "like"
        }
      ],
      filterTypeBateryStatus: [
        {
          name: "100 - 60%",
          type: "doubleInt",
          value: 100,
          from: (254 / 100) * 60,
          to: (254 / 100) * 100 + 0.1
        },
        {
          name: "60 - 0%",
          type: "doubleInt",
          value: 80,
          from: (254 / 100) * 1,
          to: (254 / 100) * 60
        },
        {
          name: "40 - 0%",
          type: "doubleInt",
          value: 60,
          from: (254 / 100) * 1,
          to: (254 / 100) * 40
        },
        {
          name: "20 - 0%",
          type: "doubleInt",
          value: 20,
          from: (254 / 100) * 1,
          to: (254 / 100) * 20
        },
        {
          name: "N_A_nepodporuje",
          value: "255"
        },
        {
          name: "N_A_nezjisten",
          value: "NULL"
        },
        {
          name: "NapajeniZExternihoZdroje",
          value: "0"
        }
      ],
      filterTypeDeviceType: [
        {
          name: "ABP",
          value: "ABP"
        },
        {
          name: "OTAA",
          value: "OTAA"
        }
      ],
      filterTypeDeviceStatus: [
        {
          name: "SEARCH_DEVICE_ACTIVE",
          value: "active"
        },
        {
          name: "SEARCH_DEVICE_PREREGISTRATION",
          value: "preregistration"
        },
        {
          name: "SEARCH_DEVICE_SUSPENDED",
          value: "suspended"
        },
        {
          name: "SEARCH_DEVICE_STANDBY",
          value: "standby"
        }
      ],
      dateSelect: [
        {
          name: "FROM_TO",
          value: "from_to"
        },
        {
          name: "TODAY",
          value: "today"
        },
        {
          name: "YESTERDAY",
          value: "yesterday"
        },
        {
          name: "THIS_WEEK",
          value: "thisWeek"
        },
        {
          name: "LAST_30_DAYS",
          value: "last30days"
        }
      ],
      item: {
        name: "",
        subName: "",
        type: "",
        subType: "",
        query: "",
        value: "",
        arrayValue: [],
        fullText: "",
        operator: [
          {
            name: "",
            value: "",
            from: "",
            to: ""
          }
        ],
        dateRange: [new Date().setDate(new Date().getDate() - 5), new Date()]
      },
      groups: [],
      groupsDefault: [
        {
          items: [
            {
              name: "",
              subName: "",
              type: "",
              subType: "",
              query: "",
              value: "",
              arrayValue: [],
              fullText: "",
              operator: [
                {
                  name: "",
                  value: ""
                }
              ],
              dateRange: [new Date().setDate(new Date().getDate() - 5), new Date()]
            }
          ]
        }
      ]
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
    storedProject() {
      return this.projectStore.selectedProject
    },
    openedFilter() {
      return this.opened
    },
    allTags() {
      return this.projectStore.tagList
    },
    allDeviceGroups() {
      return this.groupsStore.groups
    }
  },
  watch: {
    storedProject() {
      this.loadServices()
    }
  },
  mounted() {
    this.getAllTags()
    this.getAllGroups()
    this.groups = this.groupsDefault
    const storage = window.localStorage
    this.saved_filters = JSON.parse(storage.getItem("filter_devices"))

    if (this.storedProject) {
      if (this.storedProject.projectId !== this.projectId) {
        this.projectStore.setProjectById(this.projectId)
      }
      this.loadServices()
    }
  },
  methods: {
    selectDate(index_group, index_item) {
      //
      const parsedTo = Date.parse(this.groups[index_group].items[index_item].dateRange[1])
      let fr = String(this.groups[index_group].items[index_item].dateRange[0])
      let tt = String(this.groups[index_group].items[index_item].dateRange[1])
      if (this.from == "1970-01-01T00:00:00.000Z") {
        const dateFrom1 = new Date(parsedTo - 31 * 24 * 60 * 60 * 1000)
        this.groups[index_group].items[index_item].dateRange[0] = dateFrom1.toISOString()
      } else if ((new Date(tt) - new Date(fr)) / 1000 / 60 / 60 / 24 > 31) {
        const dateFrom1 = new Date(parsedTo - 31 * 24 * 60 * 60 * 1000)
        this.groups[index_group].items[index_item].dateRange[0] = dateFrom1.toISOString()
        this.rangeErrorVisible = true
      } else {
        this.rangeErrorVisible = false
      }
    },
    openDateRange() {
      this.$refs.picker.togglePicker()
    },
    getMonday(d) {
      d = new Date(d)
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1)
      return new Date(d.setDate(diff))
    },
    submitFilter() {
      var filterData = []
      let g = 0
      let i = 0
      for (g = 0; g < this.groups.length; g++) {
        for (i = 0; i < this.groups[g].items.length; i++) {
          let item = this.groups[g].items[i]
          /** operator is of type doubleInt, we must create 2 parameters */
          if (item.operator && item.operator.type == "doubleInt") {
            filterData.push({
              name: item.type,
              value: item.operator.from,
              operator: "gte"
            })
            filterData.push({
              name: item.type,
              value: item.operator.to,
              operator: "lte"
            })
          } else if (item.type == "lastMessageIn") {
            let from = ""
            let to = ""
            if (item.operator.value == "from_to" && item.dateRange && item.dateRange[0] && item.dateRange[1]) {
              from = new Date(item.dateRange[0]).toISOString().slice(0, 10)
              from = from + "T00:00:00.000Z"
              to = new Date(item.dateRange[1]).toISOString().slice(0, 10)
              to = to + "T23:59:59.000Z"
            } else if (item.operator.value == "today") {
              let today = new Date().toISOString().slice(0, 10)
              from = today + "T00:00:00.000Z"
              to = today + "T23:59:59.000Z"
            } else if (item.operator.value == "yesterday") {
              let today = new Date()
              let yesterday = new Date()

              yesterday.setDate(today.getDate() - 1)
              let _yesterday = yesterday.toISOString().slice(0, 10)
              from = _yesterday + "T00:00:00.000Z"
              to = _yesterday + "T23:59:59.000Z"
            } else if (item.operator.value == "thisWeek") {
              let today = new Date()
              let monday = this.getMonday(today)

              let _monday = monday.toISOString().slice(0, 10)
              let _today = today.toISOString().slice(0, 10)

              from = _monday + "T00:00:00.000Z"
              to = _today + "T23:59:59.000Z"
            } else if (item.operator.value == "last30days") {
              let today = new Date()
              let historyDays = new Date()

              historyDays.setDate(today.getDate() - 30)

              let _today = today.toISOString().slice(0, 10)
              let _historyDays = historyDays.toISOString().slice(0, 10)
              from = _historyDays + "T00:00:00.000Z"
              to = _today + "T23:59:59.000Z"
            }
            filterData.push({
              name: item.type,
              value: from,
              operator: "gte"
            })
            filterData.push({
              name: item.type,
              value: to,
              operator: "lte"
            })

            /** parameters has dateRange **/
          } else {
            /** parametes has property arrayValue, we must combine that into the one text value */
            if (item.arrayValue && item.arrayValue.length > 0) {
              item.value = item.arrayValue.join(",")
            }

            filterData.push({
              name: item.type,
              value: item.operator && item.operator.value ? item.operator.value : item.value,
              operator: item.operator && item.operator.type ? item.operator.type : ""
            })
          }
        }
      }
      this.$emit("setFilterData", filterData)
    },
    clearFilter() {
      var group = JSON.parse(JSON.stringify({}))
      group.items = []
      group.items.push(JSON.parse(JSON.stringify(this.item)))
      this.groups = []
      this.groups.push(group)
      this.selectedParameters = []
      this.$emit("setFilterData", {})
      this.$emit("close")
    },
    addGroup(index_group) {
      //console.log("add group");
      var group = JSON.parse(JSON.stringify({}))
      group.items = []
      group.items.push(JSON.parse(JSON.stringify(this.item)))

      this.groups.splice(index_group, 0, group)
    },
    addItem(index_group, index_item) {
      this.groups[index_group].items.splice(index_item, 0, JSON.parse(JSON.stringify(this.item)))
    },
    deleteItem(index_group, index_item) {
      this.groups[index_group].items.splice(index_item, 1)

      if (!this.groups[index_group].items.length) {
        this.groups.splice(index_group, 1)
        this.selectedParameters.splice(index_group, 1)
      }
    },
    selectOption(option, index_group, index_item) {
      this.opened = ""
      this.groups[index_group].items[index_item].value = ""
      this.groups[index_group].items[index_item].arrayValue = []
      this.groups[index_group].items[index_item].operator = JSON.parse(JSON.stringify(this.item.operator))
      this.groups[index_group].items[index_item].dateRange = JSON.parse(JSON.stringify(this.item.dateRange))
      this.groups[index_group].items[index_item].name = option.name
      this.groups[index_group].items[index_item].type = option.type
      this.selectedParameters[index_group] = option.type
    },
    selectOperatorOption(option, index_group, index_item) {
      this.opened = ""
      this.groups[index_group].items[index_item].operator = option
    },
    selectValueOption(option, index_group, index_item) {
      this.opened = ""
      this.groups[index_group].items[index_item].value = option.value
    },
    addRemoveArrayValue(option, index_group, index_item) {
      if (this.groups[index_group].items[index_item].arrayValue.indexOf(option) > -1) {
        this.groups[index_group].items[index_item].arrayValue.splice(
          this.groups[index_group].items[index_item].arrayValue.indexOf(option),
          1
        )
      } else {
        this.groups[index_group].items[index_item].arrayValue.push(option)
      }
    },
    getGroupName(id) {
      let found = this.allDeviceGroups.find((x) => x.deviceGroupId === id)
      return found.deviceGroupName
    },
    prepareToSave() {
      this.isPrepareToSave = true
    },
    saveFilter() {
      const data = {
        name: this.filterName,
        data: this.groups
      }

      this.saveToLocalStorage(data)
      this.filterName = ""
      this.isPrepareToSave = false
    },
    saveToLocalStorage(data) {
      const storage = window.localStorage
      var filter_devices = JSON.parse(storage.getItem("filter_devices"))

      if (filter_devices && filter_devices.length) {
        filter_devices.push(data)
      } else {
        const items = []
        items.push(data)
        filter_devices = items
      }

      this.saved_filters = filter_devices

      storage.setItem("filter_devices", JSON.stringify(filter_devices))
    },
    useSavedFilter(item) {
      this.groups = item.data
    },
    async getAllTags() {
      await this.projectStore.getAllTags()
    },
    async getAllGroups() {
      await this.groupsStore.getGroups()
    },
    loadServices() {
      this.allServices = []
      axios
        .get(process.env.VUE_APP_API + "/projects/" + this.storedProject.projectId + "/services?limit=1000")
        .then((result) => {
          this.allServices = result.data.data
          for (let i = 0; i < result.data.data.length; i++) {
            if (result.data.data[i].suspended == true || result.data.data[i].discontinued == true) {
              result.data.data[i].notSelectable = true
              result.data.data[i].customRowClass = "gray-text-light"
            }

            if (result.data.data[i].suspended == false && result.data.data[i].discontinued == false) {
              result.data.data[i].custState = "Aktivní"
            } else if (result.data.data[i].suspended == true && result.data.data[i].discontinued == false) {
              result.data.data[i].custState = "Suspendovaná"
            } else if (result.data.data[i].discontinued == true) {
              result.data.data[i].custState = "Deaktivní"
            }
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss">
.extended-search {
  margin-top: 20px;
  background-color: #f4f5f5;
  border-radius: 4px;
  padding: 5px 20px 20px 20px;
}

.extended-search__group {
  position: relative;
  margin-top: 10px;
  // padding: 20px;
  background: #fff;
  border-radius: 4px;
  border-bottom: 1px solid #e8e8e8;
}

.extended-search__group:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  right: 60px;
  width: 1px;
  background-color: #eeeeee;
}

.extended-search__item {
  padding: 15px;
}

.extended-search__item__select {
  float: left;
}

.extended-search__item__select .custom-control__select {
  min-width: 250px;
  max-width: 600px;

  @media screen and (max-width: 1400px) {
    min-width: 200px;
    max-width: 200px;
  }
}

.extended-search__item__controll {
  float: left;

  @media screen and (max-width: 991px) {
    height: 100%;
  }
}

.extended-search__item__delete {
  float: right;
}

.extended-search__item button {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
}

.extended-search__item__select {
  @media screen and (max-width: 991px) {
    display: block !important;
    margin-left: 0;
  }
}

body .custom-control__custom-input {
  @media screen and (max-width: 991px) {
    display: block !important;
    margin-left: 0 !important;
    width: 100%;
  }
}

.extended-search__item__group {
  @media screen and (max-width: 991px) {
    display: block !important;
    margin-left: 0;
    width: 100%;
  }
}

.extended-search__item__group .custom-control__select {
  @media screen and (max-width: 991px) {
    display: block !important;
    margin-left: 0 !important;
    width: 100%;
    margin-top: 8px;
  }
}

.extended-search__item__group .custom-control__custom-input {
  @media screen and (max-width: 991px) {
    margin-top: 8px;
  }
}

.extended-search__item__wrapper {
  flex-wrap: wrap;
  padding-right: 20px;

  @media screen and (max-width: 991px) {
    display: block !important;
  }
}

.extended-search__item__controll button {
  display: inline-block;
  margin-left: 30px;
  color: #f99d1c;

  &:focus {
    outline: none;
  }
}

.extended-search__item__controll button span {
  position: relative;
  top: -1px;
  display: inline-block;
  border-radius: 50%;
  border: 1px solid #f99d1c;
  width: 14px;
  height: 14px;
  font-size: 13px;
  line-height: 1;
  text-align: center;
  vertical-align: middle;
}

.extended-search__item__controll button u {
  display: inline-block;
  margin-left: 4px;
}

.extended-search__item__controll button:hover u {
  text-decoration: none;
}

.extended-search__controll {
  margin-top: 14px;
  padding-bottom: 10px;
}

.extended-search__btn {
  padding: 0;
  margin: 0;
  border: none;
  background: none;

  &:focus {
    outline: none;
  }
}

.extended-search__btn--clear {
  font-weight: 300;
  text-decoration: underline;
  color: #212529;
  margin-left: 20px;
  font-size: 1rem;
  height: 47px;
  padding-top: 6px;

  &:hover {
    text-decoration: none;
  }
}

.extended-search__btn--save {
  color: #f99d1c;
  font-weight: 300;
  text-decoration: underline;
  height: 47px;

  &:hover {
    text-decoration: none;
  }
}

.extended-search__btn--submit {
  display: inline-block;
  font-weight: 700;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.75rem 1.25rem;
  font-size: 1rem;
  line-height: 1.35rem;
  border-radius: 0.25rem;
  -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;

  background-color: #f99d1c;
  border-color: #f99d1c;
  color: #fff;

  &:hover {
    background-color: #eb8900;
    border-color: #eb8900;
  }
}

.custom-select {
  min-width: 200px;
  position: relative;
}

.custom-select__selected {
  height: 50px;
  cursor: pointer;
  // line-height: 50px;
}

.custom-select__options {
  position: absolute;
  z-index: 9991;
  top: 100%;
  left: 0;
  width: 240px;
  background: #fff;
  display: none;
  cursor: pointer;
}

.custom-select.active .custom-select__options {
  display: block;
  border: 1px solid #f2f2f2;
}

.custom-select__option {
  padding: 10px 16px;
  cursor: pointer;
}

.extended-search__inner {
}

.extended-search__inner--left {
  float: left;
}

.extended-search__inner--right {
  float: right;
}

.extended-search-saved {
  margin-top: 20px;
}

.extended-search-saved ul {
  list-style-type: none;
}

.extended-search__group__title {
  color: #809092;
  font-weight: 700;
  font-size: 1.2rem;
  margin-top: 2rem;
}

.extended-search__rules .extended-search__wrapper:first-child .extended-search__group__title {
  display: none;
}

.type-date-select {
  margin-left: 8px;
}

body .vue-daterange-picker .form-control.reportrange-text {
  padding: 0px 10px !important;
  line-height: 45px !important;
  height: auto !important;
}

.type-date-select .vue-daterange-picker span {
  color: #5d696b;
  font-weight: 300;
}

.extended-search__item__select .custom-control__custom-input input {
  padding: 11px 14px 12px;
}
</style>
